<template>
  <div id="app">
  <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  data() {
    return {
    }
  },
  methods: {

  },
  mounted() {

  }
}
</script>

<style lang="scss">
html,body,#app {
  height: 100%;
  width: 100%;
}
</style>
